import { store } from '../../store/store';
import {
    userCityIdSelector,
    userAgencyIdSelector,
    userInAgencyIdSelector,
    userIdSelector,
    userEmailSelector,
} from '../../store/user/user.selectors';
import { userAgenciesSelector } from '../../store/user-info/user-info.selectors';


// get the global city and agency ids selected by the user
export const getUserCityId = () => userCityIdSelector(store.getState());
export const getUserAgencyId = () => userAgencyIdSelector(store.getState());
export const getUserInAgencyId = () => userInAgencyIdSelector(store.getState());
export const getUserAgencies = () => userAgenciesSelector(store.getState());
export const getUserId = () => userIdSelector(store.getState());
export const getUserEmail = () => userEmailSelector(store.getState());
export const getLytHqId = () => {
    try {
        const { list } = userAgenciesSelector(store.getState());
        const filteredAgencies = Array.isArray(list) ? list.filter(agency => agency?.agencies_long_name === 'LYT') : [];
        return filteredAgencies.length > 0 ? filteredAgencies[0]?.agencies_id : null;
    } catch (error) {
        console.error('Error getting LYT HQ ID:', error);
        return null;
    }
};

/**
 * Build a URL with properly encoded query parameters using URLSearchParams.
 * Null/undefined values are silently skipped.
 *
 * @param {string} path - The base URL path (e.g. '/info/dashboard/charts/foo')
 * @param {Object} params - Key-value pairs for query parameters.
 *                          Values that are null or undefined are omitted.
 * @returns {string} The full URL string with encoded query parameters.
 *
 * @example
 *   buildUrl('/users/email', { email: 'a+b@example.com' })
 *   // => '/users/email?email=a%2Bb%40example.com'
 *
 *   buildUrl('/routes', { agencies_id: 'trimet', period: 'LAST_24_HOURS' })
 *   // => '/routes?agencies_id=trimet&period=LAST_24_HOURS'
 */
export const buildUrl = (path, params = {}) => {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value != null) {
            searchParams.append(key, String(value));
        }
    }
    const qs = searchParams.toString();
    return qs ? `${path}?${qs}` : path;
};
